// extracted by mini-css-extract-plugin
export default {"container":"Pages_container__YDc1x"};